module.exports = "/assets/d21e85ab9732e409475fcb8be0a90f44.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/DR.png
// module id = 1311
// module chunks = 0